"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetricTitle = void 0;
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var Localize_1 = require("../../gen-src/Localize");
var MetricTitle = function (props) {
    return (React.createElement("div", { role: "heading", "aria-level": 1, "aria-label": Localize_1.Messages.ariaLabelMetricName(), "data-tb-test-id": "metric-title", style: titleStyle }, props.metricName));
};
exports.MetricTitle = MetricTitle;
var Colors = widgets_1.TabStyles.Colors;
var titleStyle = {
    color: Colors.L9,
    fontSize: '24px',
    lineHeight: 'normal',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
};
//# sourceMappingURL=MetricTitle.js.map